import { connect } from 'react-redux';
import { push } from 'redux-first-history';
import { getUrlString, updateSearchObject } from '../../../../utils/shared/urlUtils';
import TrcProbeDetails from '../../../../features/probeDetails/shared/trc/TrcProbeDetails';
import { fetchItemLevelDetails } from '../../../../api/results/shared/resultActions';
import LinkWrapper from '../../../../features/navigation/LinkWrapper';
import { BASE_URLS, ASSESSMENT } from '../../../../constants/reading/ApiConstants';
import VALUES from '../../../../constants/reading/TrcConstants';
import { LANGUAGE } from '../../../../constants/shared/CommonConstants';
import SkylightClient from '../../../../api/clients/reading/SkylightClient';
import { selectors } from '../../../../root/reading/root';

const mapStateToProps = state => ({
    location: selectors.getLocation(state),
    baseUrl: BASE_URLS.BASE_URL,
    values: VALUES,
    language: LANGUAGE.ENGLISH,
    themeClassName: 'blue',
    LinkWrapper,
});

const mapDispatchToProps = dispatch => ({
    selectBook: (bookId, location) => {
        dispatch(
            push(
                getUrlString(location.pathname, {
                    ...updateSearchObject(location, ['bookId', 'tab'], { bookId }),
                }),
            ),
        );
    },
    fetchItemLevelDetails: result =>
        dispatch(fetchItemLevelDetails(ASSESSMENT.TRC, SkylightClient, Array.of(result))),
});

export default connect(mapStateToProps, mapDispatchToProps)(TrcProbeDetails);
